import React, {PropTypes} from 'react';
import moment from 'moment';

const AuditCaptainHeader = ({
  captainName,
  captainEmail,
  startDate,
  endDate,
  tournamentName
}) => {
  return (
  <div className="list-group-item-labeled"> 
    <div className="list-group-item-labeled-child"
      style={{width: 250}}>
      <span>{'Captain'}</span>
      <span>{captainName}</span>
      <span>{captainEmail}</span>
    </div> 
    <div className="list-group-item-labeled-child"
      style={{width: 250}}>
      <span>{'Tournament Name'}</span>
      <span>{tournamentName}</span>
    </div> 
    <div className="list-group-item-labeled-child"
      style={{width: 120}}>
      <span>{'Start'}</span>
      <span>
              {
                startDate
                ? `${moment.parseZone(startDate).format('MMM Do, YYYY')}`
                : '-'
              }
        </span>
    </div> 
    <div className="list-group-item-labeled-child"
      style={{width: 120}}>
      <span>{'End'}</span>
      <span>
              {
                endDate
                ? `${moment.parseZone(endDate).format('MMM Do, YYYY')}`
                : '-'
              }
        </span>
    </div>  
  </div>
  );  
};

AuditCaptainHeader.propTypes = {
  captainName: PropTypes.string,
  captainEmail: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  tournamentName: PropTypes.string
};

AuditCaptainHeader.defaultProps = {
};

export default AuditCaptainHeader;



// WEBPACK FOOTER //
// ./src/features/admin/audit/captainAudit/AuditCaptainHeader.jsx